import RewardTax from './RewardTax';

export default RewardTax;
